import 'reset-css';
import './scss/index.scss';
import React, {useEffect} from 'react';

import {utils} from './utils';
import {theme} from './constants';
import {components} from './components';

const features = [
  'PWA Ready',
  '30 + screens',
  'Easy to Edit',
  'Free Updates',
  'Reusable Components',
  'User Friendly Design',
  'Good color combination',
  'Fast Performance',
];

function App() {
  const checkScreenWidth = () => {
    if (window.innerWidth <= 1180) {
      window.location.href = 'https://apitex-pwa.vercel.app/'; // Замените на нужный URL
    }
  };

  useEffect(() => {
    checkScreenWidth();
    window.addEventListener('resize', checkScreenWidth);
    return () => {
      window.removeEventListener('resize', checkScreenWidth);
    };
  }, []);

  const renderFeatures = (): JSX.Element => {
    return (
      <div style={{marginBottom: 40, ...utils.rowCenter(), marginTop: 40}}>
        <ul
          style={{
            listStyleType: 'none',
            padding: 0,
            marginRight: 50,
          }}
        >
          {features.slice(0, 4).map((tech) => (
            <li
              key={tech}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  width: 6,
                  height: 6,
                  backgroundColor: theme.colors.mainColor,
                  borderRadius: 10,
                  marginRight: 10,
                }}
              ></div>
              <div
                style={{
                  color: theme.colors.bodyTextColor,
                  ...theme.fonts.SourceSansPro_400Regular,
                }}
              >
                {tech}
              </div>
            </li>
          ))}
        </ul>
        <ul
          style={{
            listStyleType: 'none',
            padding: 0,
          }}
        >
          {features.slice(4, 8).map((tech) => (
            <li
              key={tech}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  width: 6,
                  height: 6,
                  backgroundColor: theme.colors.mainColor,
                  borderRadius: 10,
                  marginRight: 10,
                }}
              ></div>
              <div
                style={{
                  color: theme.colors.bodyTextColor,
                  ...theme.fonts.SourceSansPro_400Regular,
                }}
              >
                {tech}
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const renderPhone = (): JSX.Element => {
    return (
      <div
        style={{
          width: 374,
          height: 768,
          borderWidth: 8,
          borderStyle: 'solid',
          borderColor: theme.colors.mainColor,
          borderRadius: 29,
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            borderRadius: 20,
          }}
        >
          <iframe
            src='https://apitex-pwa.vercel.app/'
            width='100%'
            height='100%'
            style={{
              border: 0,
              borderRadius: 12,
              overflow: 'scroll',
              scrollbarWidth: 'none' /* Firefox */,
              msOverflowStyle: 'none' /* IE 10+ */,
            }}
            allowFullScreen={true} // Исправлено на правильное название атрибута
          ></iframe>
        </div>
      </div>
    );
  };

  const renderLogoWithQRCode = (): JSX.Element => {
    return (
      <div style={{...utils.rowCenter(), marginBottom: 30}}>
        <div
          style={{
            width: 90,
            height: 90,
            marginRight: 20,
            borderRadius: 12,
            ...utils.flexCenter(),
            border: `1px solid ${theme.colors.bodyTextColor}30`,
          }}
        >
          <img
            src={require('./assets/logo.png')}
            style={{width: 75, height: 75}}
          />
        </div>
        <img
          src={require('./assets/qr-code.png')}
          style={{
            width: 90,
            height: 90,
            border: `1px solid ${theme.colors.bodyTextColor}30`,
            borderRadius: 12,
            marginRight: 20,
          }}
        />
      </div>
    );
  };

  const renderName = (): JSX.Element => {
    return (
      <h1
        style={{
          fontSize: 32,
          marginBottom: 20,
          color: theme.colors.mainColor,
          ...theme.fonts.SourceSansPro_600SemiBold,
        }}
      >
        Apitex - Mobile Banking
      </h1>
    );
  };

  const renderDescription = (): JSX.Element => {
    return (
      <div
        style={{
          color: theme.colors.bodyTextColor,
          marginBottom: 20,
          maxWidth: 550,
          lineHeight: 1.5,
          ...theme.fonts.SourceSansPro_400Regular,
        }}
      >
        Apitex is a cutting-edge Progressive Web Application (PWA) that enhances
        mobile banking. It merges the convenience of a mobile app with the
        seamless experience of a web application, providing a versatile and
        user-friendly platform for managing finances on the go.
      </div>
    );
  };

  const renderButtons = (): JSX.Element => {
    return (
      <div style={{marginBottom: 80, display: 'flex', ...theme.flex.rowCenter}}>
        <components.Button
          title='Purchase'
          href='https://themeforest.net/user/george_fx/portfolio'
          containerStyle={{marginRight: 20}}
        />
        <components.Button
          title='Browser version'
          colorScheme='transparent'
          href='https://apitex-pwa.vercel.app/'
        />
      </div>
    );
  };

  const renderIfNeedAssistance = (): JSX.Element => {
    return (
      <div style={{color: theme.colors.bodyTextColor}}>
        * need asistance? contact me via{' '}
        <a
          href='https://t.me/George_Kuliashvili'
          style={{
            color: theme.colors.mainColor, // Замените 'blue' на желаемый цвет
            textDecoration: 'none', // Убирает подчеркивание
            ...theme.fonts.SourceSansPro_600SemiBold,
          }}
        >
          Telegram
        </a>
      </div>
    );
  };

  const renderDetails = (): JSX.Element => {
    return (
      <div style={{marginLeft: 70}}>
        {renderLogoWithQRCode()}
        {renderName()}
        {renderDescription()}
        {renderFeatures()}
        {renderButtons()}
        {renderIfNeedAssistance()}
      </div>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {renderPhone()}
        {renderDetails()}
      </>
    );
  };

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'rgba(249, 251, 254, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {renderContent()}
    </div>
  );
}

export default App;
